import { useEffect } from 'react';

import { KEYTYPE } from '../../utils/keyConstants';
import styles from './ButtonServicing.module.css';

export enum ButtonColorScheme {
  fillBranded = 'fillBranded',
  fillImprint = 'fillImprint',
  ghostBranded = 'ghostBranded',
  ghostImprint = 'ghostImprint',
  emptyBranded = 'emptyBranded',
  emptyImprint = 'emptyImprint',
}

export enum ButtonSize {
  small = 'small',
  default = 'default',
  xsmall = 'xsmall',
}

interface ButtonProps {
  value: string;
  pill?: boolean;
  empty?: boolean;
  borderless?: boolean;
  icon?: string;
  disabled?: boolean;
  hideOnMobile?: boolean;
  loading?: boolean;
  handleClick?: any;
  colorScheme?: ButtonColorScheme;
  size?: ButtonSize;
  overrideColor?: string;
}

export default function ButtonServicing({
  value,
  pill,
  empty,
  borderless,
  icon,
  disabled,
  hideOnMobile,
  loading,
  handleClick,
  colorScheme,
  size,
  overrideColor,
}: ButtonProps) {
  useEffect(() => {}, [icon, disabled]);
  const getClasses = () => {
    const classList = [''];
    if (disabled) {
      classList.push(styles.disabled);
    }
    if (pill) {
      classList.push(styles.pill);
    }
    if (empty) {
      classList.push(styles.empty);
    }
    if (borderless) {
      classList.push(styles.borderless);
    }
    if (hideOnMobile) {
      classList.push(styles.hideOnMobile);
    }

    // prettier-ignore
    if (colorScheme) {
      switch (colorScheme) {
        case ButtonColorScheme.fillBranded: classList.push(styles.fillBranded); break;
        case ButtonColorScheme.fillImprint: classList.push(styles.fillImprint); break;
        case ButtonColorScheme.ghostBranded: classList.push(styles.ghostBranded); break;
        case ButtonColorScheme.ghostImprint: classList.push(styles.ghostImprint); break;
        case ButtonColorScheme.emptyBranded: classList.push(styles.emptyBranded); break;
        case ButtonColorScheme.emptyImprint: default: classList.push(styles.emptyImprint); break;
      }
    }

    if (size) {
      switch (size) {
        case ButtonSize.small:
          classList.push(styles.small);
          break;
        case ButtonSize.xsmall:
          classList.push(styles.xsmall);
          break;
        case ButtonSize.default:
        default:
          break;
      }
    }

    return classList.join(' ');
  };

  return (
    <div>
      <button
        className={getClasses()}
        onClick={!disabled && !loading ? handleClick : undefined}
        style={{
          color: overrideColor ? overrideColor : undefined,
        }}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key.toUpperCase() === KEYTYPE.ENTER && !disabled && !loading) {
            handleClick();
          }
        }}
      >
        {!loading ? value : ''}
      </button>
      {getClasses().includes(styles.pill) && !disabled && loading && (
        <div className={styles.spinner}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </div>
  );
}
